import { paramsToJson } from 'shared/lib/paramsToJson'
import { useUrlStateManager } from './useUrlStateManager'
import { jsonToParams } from 'shared/lib/jsonToParams'

export const useUrlStateManagerDefault = (initialState: any = {spyId: undefined, filters: undefined}) => {
    const [urlState, setUrlState] = useUrlStateManager(initialState, {
            persistKeys: ['spyId', 'filters'],
            deserializers: {
                'filters': (item) => {
                    return paramsToJson(item)
                }
            },
            serializers: {
                'spyId': (itemState) => {
                    return itemState
                },
                'filters': (itemState) => {
                    let filteredState: any = {}
                    const value = itemState

                    Object
                        .keys(value)
                        .forEach((key) => {
                            if (value[key] === undefined){
                                return
                            }

                            if (value[key].length === 0){
                                return
                            }

                            filteredState[key] = (value[key])        
                    })

                    if (Object
                            .keys(filteredState)
                                .length === 0 ){
                        return undefined
                    }

                    return jsonToParams(filteredState)
                },
            }
        }
    )

    return {
        urlState,
        setUrlState
    }
}

